import { render, staticRenderFns } from "./ImageAdvertising.vue?vue&type=template&id=f4290bae"
import script from "./ImageAdvertising.vue?vue&type=script&lang=js"
export * from "./ImageAdvertising.vue?vue&type=script&lang=js"
import style0 from "./ImageAdvertising.vue?vue&type=style&index=0&id=f4290bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports